import { z } from '@harvestiq/zod';
import { claimDocumentWithDownloadUrlSchema } from './claim-document-with-download-url';

export const downloadClaimDocumentParamsSchema = z.object({
  claimDocumentId: z.string().uuid(),
});

export type DownloadClaimDocumentParams = z.infer<
  typeof downloadClaimDocumentParamsSchema
>;

export const downloadClaimDocumentResponseSchema = z.object({
  claimDocument: claimDocumentWithDownloadUrlSchema.optional(),
  error: z.string().optional(),
});

export type DownloadClaimDocumentResponse = z.infer<
  typeof downloadClaimDocumentResponseSchema
>;
